import Layout from '@/layout/index.vue'

// GIMMATEK 基本參數設定只保留會員、通知、預約模組運作所需的參數（CNCY-10766）
// - Line 串接設定：LINE 通知、LINE 通知紀錄查詢依賴
// - 營業時間設定：排班行事曆批次排班依賴
// - 快速收款連結設定：預約列表顯示
export const parametersRoutes = [
  {
    path: '/parameters',
    name: 'Parameters',
    component: Layout,
    redirect: '/parameter-settings',
    hidden: true,
    children: [
      {
        path: '/parameter/line-settings',
        name: 'LineSettings',
        component: () => import('@/views/Parameters/LineSettings/LineSettings.vue'),
        meta: {
          title: 'Line串接設定',
          action: 'admin.lineConfig.page',
        },
      },
      {
        path: '/parameter/member-center',
        name: 'MembersCenter',
        // hidden: true,
        component: () => import('@/views/Parameters/MemberCenter/MemberCenter'),
        meta: {
          title: '會員中心模組參數設定',
          action: 'admin.memberCenterConfig.page',
        },
      },
      // 預約
      {
        path: '/parameter/reservations/reservation-parameter',
        name: 'ReservationParameter',
        component: () => import('@/views/Parameters/ReservationParameters/ReservationParameters'),
        meta: {
          title: 'parameterSetting.reservationParameterSetting.title',
          action: 'admin.appointmentConfig.page',
        },
      },
      {
        path: 'reservations/payment-settings',
        name: 'EditReservationPaymentSettings',
        hidden: true,
        component: () =>
          import(
            '@/views/Parameters/ReservationParameters/components/EditReservationPaymentSettings/EditReservationPaymentSettings.vue'
          ),
        meta: {
          title: '收費模式設定',
          action: 'admin.appointmentConfig.page',
        },
      },
      {
        path: '/parameter/shop-business-time-settings',
        name: 'BusinessTimeSettings',
        component: () => import('@/views/Parameters/BusinessTime/BusinessTimeSettings.vue'),
        meta: {
          title: 'parameterSetting.businessTimeSetting.title',
          action: 'admin.shopBusinessTime.page',
        },
      },
      {
        path: '/parameter/reservations/quick-payment-link-settings',
        name: 'QuickPaymentLinkSettings',
        component: () => import('@/views/Parameters/QuickPaymentLinkSettings/QuickPaymentLinkSettings.vue'),
        meta: {
          title: '快速收款連結設定',
          action: 'planModule.appointmentRiskGuard.enable',
        },
      },
    ],
  },
]
